export const config = {
  title: "NumberNine Hair Care",
  meta: {
    description:
      "NumberNine Hair Care is a boutique barber studio in Baltimore, MD offering premium haircuts, beard trims, and VIP services by appointment.",
    keywords: [
      "NumberNine Hair Care Baltimore",
      "Baltimore barber",
      "fade haircut Baltimore",
      "beard trim Baltimore",
      "VIP hair services"
    ],
    author: "NumberNine Hair Care",
    canonicalUrl: "https://numberninehc.com/",
  },
  sections: {
    header: { businessName: "NumberNine Hair Care" },
    sectionB: {
      heroTitle: "NumberNine Hair Care",
      heroSubtitle: "Premium Barber Studio in Baltimore, MD",
      learnAboutText: "Explore Our Services",
      phoneNumber: "2405568294",
      phoneLabel: "(240) 556‑8294",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1973194125/photo/hairdresser-shaping-eyebrows-of-man-client-using-razor-in-barbershop.jpg?s=612x612&w=0&k=20&c=VsiQg5qDRkQB9-BUdvhJMfbc1AeS6uSBFUcHKDC6xo8=",
      cardData: [
        {
          title: "Men’s Haircut & Beard",
          description: "Any fade/taper with beard or goatee, straight razor finish.",
        },
        {
          title: "Line-up Only",
          description: "Crisp line-up and beard detail with a straight razor.",
        },
        {
          title: "VIP Treatment",
          description:
            "One-hour service with shampoo, conditioner, enhancements & more.",
        },
      ],
      description:
        "Located in Baltimore and operating by appointment, NumberNine Hair Care delivers customized haircut and grooming experiences—including fade haircuts, beard trims, and VIP packages with enhancements.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Available services include standard haircuts, VIP treatments, beard grooming, and house-call appointments.",
      cards: [
        {
          title: "Haircut + Beard",
          description:
            "Sharp fade/taper haircut with beard or goatee, straight razor touch.",
          imageSrc: "https://numberninehc.com/wp-content/uploads/2025/06/image15-1.jpeg",
          imageAlt: "Haircut and Beard",
        },
        {
          title: "Line-up Only",
          description:
            "Crisp line-up and beard detail, ideal for quick styling refresh.",
          imageSrc: "https://numberninehc.com/wp-content/uploads/2025/06/image8-1-1.jpeg",
          imageAlt: "Line‑up Only",
        },
        {
          title: "VIP Treatment",
          description:
            "Deluxe one-hour appointment: shampoo, enhancements, and premium finish.",
          imageSrc: "https://numberninehc.com/wp-content/uploads/2025/06/image13-1-1.jpeg",
          imageAlt: "VIP Treatment",
        },
      ],
      otherServicesTitle: "Additional Features",
      otherServicesList: [
        "House-call VIP service available",
        "Online booking via StyleSeat",
        "Consistently rated 5.0 stars",
        "Welcome new clients anytime",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://numberninehc.com/wp-content/uploads/2025/06/image17.jpeg",
        alt: "NumberNine Hair Studio",
      },
      aboutText: [
        "NumberNine Hair Care is a boutique barber studio in Baltimore, MD, focused on delivering personalized grooming experiences by appointment.",
        "With hundreds of bookings and consistently 5.0★ ratings, we’re trusted by clients seeking top-level fade haircuts and VIP treatment.",
      ],
    },
    sectionE: {
      profileImage: "https://numberninehc.com/wp-content/uploads/2025/06/11-18-e1749743175837.jpg",
      profileAlt: "NumberNine Hair Care Logo",
      businessName: "NumberNine Hair Care",
      contact: {
        phone: "2405568294",
        phoneLabel: "(240) 556‑8294",
        email: "contact.justache@gmail.com",
        website: "https://numberninehc.com/",
        address: "5471 Baltimore National Pike Ste 163, Baltimore, MD 21229",
      },
      socialMedia: {
        instagram: "https://www.instagram.com/numberninehc/",
        facebook: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "5471 Baltimore National Pike Ste 163, Baltimore, MD 21229",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3873.0!2d-76.650!3d39.3!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sBaltimore%20National%20Pike%2C%20Baltimore%2C%20MD!5e0!3m2!1sen!2sus!4v1718700000000!5m2!1sen!2sus",
    },
  },
};
export default config;
